var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDropDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 10 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Navigation-(21)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ic arrow drop down"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 0 5 5 10 0 0 0",
    fill: "#efeff0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDownWhite);
export default __webpack_public_path__ + "static/media/arrow_drop_down_white.a05127719b4a94ba73c65320400af1ad.svg";
export { ForwardRef as ReactComponent };